
export const GUIDE_TYPES = [
  { value: 'walk_guide', label: 'Walking Guide' },
  { value: 'food_guide', label: 'Food Guide' },
  { value: 'nightlife_guide', label: 'Nightlife Guide' },
  { value: 'cultural_guide', label: 'Cultural Guide' },
  { value: 'shopping_guide', label: 'Shopping Guide' },
  { value: 'local_tips', label: 'Local Tips' },
] as const;

export type GuideType = typeof GUIDE_TYPES[number]['value'];
